import React, { useEffect } from "react";

import PageSkeleton from "../components/PageSkeleton";

function Fees () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <PageSkeleton
            titleKey="pages.fees.title"
            descriptionKey="pages.fees.description"
            sections={[
                "pages.fees.sections.1",
                "pages.fees.sections.2",
                "pages.fees.sections.3",
                "pages.fees.sections.4",
                "pages.fees.sections.5",
                "pages.fees.sections.6",
            ]}
        />
    );
}

export default Fees;
